// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.25}
      d="M0.666016 17.3337L1.83754 13.0538C1.11463 11.801 0.734766 10.3809 0.73546 8.92463C0.737543 4.37185 4.4424 0.666992 8.99449 0.666992C11.2035 0.667687 13.2771 1.5281 14.8369 3.08921C16.3959 4.65033 17.2542 6.72533 17.2535 8.93227C17.2514 13.4857 13.5466 17.1906 8.99449 17.1906C7.61254 17.1899 6.25074 16.8434 5.04449 16.185L0.666016 17.3337ZM5.24727 14.6899C6.41115 15.3809 7.52227 15.7948 8.99171 15.7955C12.775 15.7955 15.857 12.7163 15.8591 8.93088C15.8605 5.13783 12.7931 2.06283 8.99727 2.06144C5.21115 2.06144 2.13129 5.1406 2.1299 8.92533C2.12921 10.4705 2.58199 11.6274 3.3424 12.8378L2.64865 15.3712L5.24727 14.6899ZM13.1549 10.8955C13.1035 10.8094 12.966 10.758 12.7591 10.6545C12.5528 10.551 11.5382 10.0517 11.3487 9.98296C11.1598 9.91421 11.0223 9.87949 10.8841 10.0864C10.7466 10.2927 10.3507 10.758 10.2306 10.8955C10.1105 11.033 9.98963 11.0503 9.78338 10.9469C9.57713 10.8434 8.91185 10.626 8.12365 9.92255C7.51046 9.37533 7.09588 8.69963 6.97574 8.49269C6.8556 8.28644 6.96324 8.17463 7.06602 8.07185C7.15907 7.97949 7.27227 7.83088 7.37574 7.71005C7.4806 7.5906 7.51463 7.50449 7.58407 7.3663C7.65282 7.2288 7.61879 7.10796 7.56671 7.00449C7.51463 6.90171 7.10213 5.88574 6.9306 5.47255C6.76254 5.07046 6.5924 5.12463 6.46602 5.11838L6.07018 5.11144C5.93268 5.11144 5.70907 5.16283 5.52018 5.36977C5.33129 5.57671 4.79796 6.07533 4.79796 7.0913C4.79796 8.10727 5.53754 9.08852 5.64032 9.22602C5.74379 9.36352 7.09518 11.4482 9.16532 12.342C9.65768 12.5545 10.0424 12.6816 10.3417 12.7767C10.8362 12.9337 11.2862 12.9114 11.6417 12.8587C12.0382 12.7996 12.8625 12.3594 13.0348 11.8774C13.207 11.3948 13.207 10.9816 13.1549 10.8955Z"
    />
  </svg>
);
const IconWhatsapp = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconWhatsapp;
